import { combineReducers } from '@reduxjs/toolkit';
import profiles from './profiles';
import profileTypes from './profileTypes';
import userStatus from './userStatus';

const rootReducer = combineReducers({
  profiles,
  profileTypes,
  userStatus,
});

export default rootReducer;
